<template>
  <footer class="footer" id="footer">
    <div class="container whiteBack">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-6 pad20">
                    <p class="txtnegro14"><strong>Información del proceso:</strong></p>
                    <p class="txtnegro14">Emitido por Orange</p>
                </div>
                <div class="col-md-6 pad20 text-right">
                    <p class="txtnegro14">Número de identificación de contratatación electrónica: {{idContract}}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="footerLegal">
      <p>
        <br><br> © Digitel on Trusted Services, S.L.U. <span class="legalsep"> - </span> Todos los derechos reservados
      </p>
    </div>
  </footer>
</template>
<script>
import constants from '@/assets/environments/constants.json';
export default {
    name:'common-footer',
    data(){
        return{
            footAbs:false,
            footRel:true,
            idContract:''
        }
    },
    created: function(){
        window.addEventListener('resize', this.handleFooter)
    },
    mounted(){
        this.handleFooter()
        if(this.$session.has('id')){
            this.idContract = this.$session.get('id')
        }else{this.getId();}
    },
    watch:{
        $route (to, from){
            this.handleFooter()
        }
    } ,
    methods:{
        handleFooter(){
            if( (window.devicePixelRatio < constants.minZoom && this.$route.name!=constants.resumeView) ||
             (this.$route.name ==constants.resumeView && window.devicePixelRatio < constants.resumeZoom)){
                this.footAbs=true
                this.footRel=false
            }
            else{
                this.footAbs=false
                this.footRel=true
            }

        },
        getId(){
            this.idContract = this.$route.params.id_container
        }
    }
}
</script>



// WEBPACK FOOTER //
// ./src/components/footer/footer.vue